<div *ngIf="!firstLoading" class="display">
    <app-display-standart-template *ngIf="selectedTemplate === layoutPrincipal.valueOf()"
        [logoString64]="this.logoString64" [lastHourWaitingTimeAverage]="lastHourWaitingTimeAverage"
        [showAverageWaitingTime]="showAverageWaitingTime" [panelTime]="panelTime" (keepAlive)="keepAlive()"
        (getServerDate)="getHealthUnitTime()">
    </app-display-standart-template>
    <app-display-layout-left-template *ngIf="selectedTemplate === layoutEsquerda.valueOf()"
        [logoString64]="this.logoString64" [lastHourWaitingTimeAverage]="lastHourWaitingTimeAverage"
        [showAverageWaitingTime]="showAverageWaitingTime" [panelTime]="panelTime" [videoFormat]="this.videoFormat"
        (keepAlive)="keepAlive()" (getServerDate)="getHealthUnitTime()" [idHealthUnit]="this.panelStruct.idHealthUnit">
    </app-display-layout-left-template>
    <app-display-layout-right-template *ngIf="selectedTemplate === layoutDireita.valueOf()"
        [logoString64]="this.logoString64" [lastHourWaitingTimeAverage]="lastHourWaitingTimeAverage"
        [showAverageWaitingTime]="showAverageWaitingTime" [panelTime]="panelTime" [videoFormat]="this.videoFormat"
        (keepAlive)="keepAlive()" (getServerDate)="getHealthUnitTime()" [idHealthUnit]="this.panelStruct.idHealthUnit">
    </app-display-layout-right-template>
    <app-display-standart-template-v2 *ngIf="selectedTemplate === layoutPrincipalV2.valueOf()"
        [logoString64]="this.logoString64" [lastHourWaitingTimeAverage]="lastHourWaitingTimeAverage"
        [showAverageWaitingTime]="showAverageWaitingTime" [panelTime]="panelTime" (keepAlive)="keepAlive()"
        (getServerDate)="getHealthUnitTime()">
    </app-display-standart-template-v2>
</div>
<app-loading-list *ngIf="firstLoading"></app-loading-list>